export default __webpack_public_path__ + "static/media/Cinzel-Regular.e885bc37.woff";